import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  listaNotificacoes: function () {
    return Vue.http.get('/api/notificacao/listanotificacoes').then(response => response.body);
  }, 
  listaNotificacoesSolicitacoes: function () {
    return Vue.http.post('/api/liberarsolicitacao').then(response => response.data);
  },
  listaPedidosNaoLiberados: function () {
    return Vue.http.get('/api/pedido/listapedidosnaoliberados').then(response => response.body);
  }, 
  listaPesquisasNaoAprovadas: function () {
    return Vue.http.get('/api/pesquisapreco/listapesquisasnaoaprovadas').then(response => response.body);
  },
  listaPesquisasPassagemNaoAprovadas: function () {
    return Vue.http.get('/api/pesquisapassagem/listapesquisasnaoaprovadas').then(response => response.body);
  },
  listaProjetosTerminando: function () {
    return Vue.http.get('/api/projetos/ProjetosTerminandoNotificacao').then(response => response.body);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/notificacoes/servico.js